import React from 'react';
import { KText, KView, PageContext } from '@/component/RtlLayout';
import { convertStyles } from '@kibt/krn-utils';
import { StyleSheet } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { $k18n } from '@/common/i18n';

import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);

const FlashProgress = ({ pageRawData }) => {
    const percent = pageRawData?.activityInfo?.saleRate || 0;

    const styles = StyleSheet.create({
        progressChild: {
            width: `${percent}%`,
            height: '100%',
            borderRadius: 9,
        },
    });

    return (
        <PageContext.Provider value={{ Styles }}>
            <KView rtlClassName={'flash-progress_wrap'}>
                <KView rtlClassName={'progress-parent'}>
                    <LinearGradient
                        start={{ x: 0.0, y: 0.0 }}
                        end={{ x: 1.0, y: 0.0 }}
                        colors={['rgba(255, 112, 51, 1)', 'rgba(255, 73, 6, 1)']}
                        style={styles.progressChild}>
                        <KText rtlClassName={'flash-progress_text'}>
                            {$k18n({ id: 'k_367075', params: { productNumber: pageRawData?.activityInfo?.stock } })}
                        </KText>
                    </LinearGradient>
                    {/* <KView style={{ width: `${percent}%` }} rtlClassName={'progress-child'}>
                        <KText rtlClassName={'flash-progress_text'}>only {pageRawData?.activityInfo?.stock} left</KText>
                    </KView> */}
                </KView>
            </KView>
        </PageContext.Provider>
    );
};

export default FlashProgress;
